import {
  Accordion as NextUiAccordion,
  AccordionItem as NextUiAccordionItem,
} from '@heroui/accordion';

export const Accordion = NextUiAccordion;
export const AccordionItem = NextUiAccordionItem;
